import * as React from 'react';
import { createRoot } from 'react-dom/client';

import AppContainer from '@module/app/AppContainer';

import './app.scss';

if (!document.documentElement.getAttribute('data-theme')) {
	document.documentElement.setAttribute('data-theme', 'light');
}

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<AppContainer />);
